import * as React from "react";

interface ExtendedImageProps {
  imageUrl?: string;
  altText?: string;
  className?: string;
  loading?: "lazy" | "eager" | undefined;
  imageSrcSet?: string;
  width?: string | number;
  height?: string | number;
}

export default function ExtendedImage({
  imageUrl = "",
  altText = "",
  className = "",
  loading = "lazy",
  imageSrcSet = "",
  width="auto",
  height="auto"
}: ExtendedImageProps) {
  return (
    <img
      src={imageUrl}
      alt={altText}
      srcSet={imageSrcSet}
      className={className}
      fetchPriority={ loading == 'eager'  ? "high" : undefined}
      width={width}
      height={height}
      loading={loading}
    />
  );
}
